/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/400-google-drive': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M6.844 10L3.96 15h9.072l2.884-5zM15.506 9l-4.619-8H5.112l4.619 8zM4.534 2L0 9.856l2.888 5L7.422 7z"/>'
  }
})
